/* eslint-disable no-undef */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'

class SimpleEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: this.props.value,
      id: this.props.id,
      wordcount: 0,
      charcount: 0,
      isChanged: false,
      keyEvents: []
    }
  }

  componentDidMount() {
    const element = document.querySelector('#simple-editor')
    element.addEventListener('paste', (event) => {
      event.preventDefault()
    })
    element.addEventListener('copy', (event) => {
      event.preventDefault()
    })
    element.addEventListener('cut', (event) => {
      event.preventDefault()
    })
    element.addEventListener('keydown', this.storeKeyEvent)
    const observer = new MutationObserver((mutations) =>
      mutations.forEach((mutation) => {
        this.setState({
          isChanged: true
        })
        this.updateWordCharCount(element)
        this.props.onChange({
          html: element.innerHTML,
          keyEvents: this.state.keyEvents
        })
      })
    )
    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.id !== nextProps.id) {
      return {
        id: nextProps.id,
        isChanged: false,
        keyEvents: []
      }
    }
    return null
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.SimpleEditorNode.innerHTML = this.props.value
    } else if (this.props.id == prevProps.id && !this.state.isChanged) {
      this.SimpleEditorNode.innerHTML = this.props.value
    } else if (this.props.value !== prevProps.value) {
      if (this.props.value === '') {
        this.SimpleEditorNode.innerHTML = this.props.value
      }
    }
  }

  getText = () => {
    const element = document.querySelector('div[contenteditable]')
    const firstTag = element.firstChild.nodeName
    const keyTag = new RegExp(
      firstTag === '#text' ? '<br' : '</' + firstTag,
      'i'
    )
    const tmp = document.createElement('p')
    tmp.innerHTML = element.innerHTML
      .replace(/<[^>]+>/g, (m, i) => (keyTag.test(m) ? '{ß®}' : ''))
      .replace(/{ß®}$/, '')
    return tmp.innerText.replace(/{ß®}/g, '\n')
  }

  updateWordCharCount = (element) => {
    const text = element.innerText.replace(/\n|\r/g, ' ')
    // this.getText()
    const cc = text.replace(/[^a-z0-9]/gi, '').length
    const wc = text.split(' ').filter((text) => {
      return text !== ''
    }).length
    this.setState({
      wordcount: wc,
      charcount: cc
    })
  }

  storeKeyEvent = (e) => {
    this.setState((prevState) => ({
      keyEvents: [...prevState.keyEvents, e.code]
    }))
  }

  clickFile = () => {
    document.getElementById('simple-editor-image-upload').click()
  }

  handleFileUpload = (e) => {
    const { onImageUpload } = this.props
    const element = document.querySelector('#simple-editor')
    if (
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png'
    ) {
      const filename = e.target.files[0].name.split(' ')
      const currentTimstamp = Date.now().toString()
      const imageName = currentTimstamp.concat(
        '-',
        filename[filename.length - 1]
      )
      var imgelement = document.createElement('img')
      imgelement.id = `${imageName}`
      imgelement.classList.add('s-e-image')
      imgelement.style.cssText = 'max-width: 60%; height: auto;'
      imgelement.src = URL.createObjectURL(e.target.files[0])
      document.getElementById('simple-editor').appendChild(imgelement)
      onImageUpload(e.target.files[0], (status, url) => {
        if (status) {
          document.getElementById(`${imageName}`).src = url
        } else {
          document.getElementById(`${imageName}`).remove()
        }
        this.props.onChange({
          html: element.innerHTML,
          keyEvents: this.state.keyEvents
        })
        document.getElementById('simple-editor-image-upload').value = ''
      })
    } else {
      document.getElementById('simple-editor-image-upload').value = ''
      alert('Only Png or Jpeg Image format is allowed')
    }
  }

  render() {
    const { containerStyle, editorStyle, showWordCharCount } = this.props
    const { wordcount, text, charcount } = this.state
    return (
      <div style={containerStyle} id='simple-editor-container'>
        <div
          style={{
            height: '35px',
            backgroundColor: '#f3f2f2'
          }}
        >
          <input
            type='file'
            accept='image/png,image/jpeg'
            id='simple-editor-image-upload'
            style={{
              display: 'none'
            }}
            onChange={this.handleFileUpload}
          />
          <img
            src='https://ik.imagekit.io/bikram/add_photo_alternate-24px_KDmBRwDhm.svg'
            style={{
              height: '25px',
              width: '25px',
              padding: '6px',
              cursor: 'pointer'
            }}
            alt='add'
            onClick={this.clickFile}
          />
        </div>
        <div
          id='simple-editor'
          style={editorStyle}
          contentEditable='true'
          suppressContentEditableWarning='true'
          ref={(node) => (this.SimpleEditorNode = node)}
        >
          {parse(text)}
        </div>
        {showWordCharCount && (
          <div
            style={{
              position: 'absolute',
              bottom: '4px',
              right: '10px',
              fontSize: '12px',
              color: 'rgb(74 74 74)'
            }}
          >
            <span>{`${wordcount} ${
              wordcount < 2 ? 'word' : 'words'
            }, ${charcount} ${
              charcount < 2 ? 'character' : 'characters'
            }`}</span>
          </div>
        )}
      </div>
    )
  }
}

SimpleEditor.defaultProps = {
  containerStyle: {
    position: 'relative',
    width: '600px',
    height: '600px',
    border: '1px solid #cec7c7',
    paddingBottom: '20px'
  },
  editorStyle: {
    width: 'calc(100% - 9px)',
    height: 'calc(100% - 62px)',
    padding: '4px',
    outline: 'none',
    overflow: 'auto',
    '&:focus': {
      outline: '0px'
    }
  },
  onChange: () => {},
  value: '',
  id: '1',
  showWordCharCount: true
}

SimpleEditor.propTypes = {
  containerStyle: PropTypes.object,
  onImageUpload: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  id: PropTypes.string,
  showWordCharCount: PropTypes.bool
}

export default SimpleEditor
